export type Document = {
  id?: string;
  documentoUid: string;
  nombre: string;
  estado?: string;
  path?: string;
  tokenDescarga?: string;
  cantidadDescargas?: number;
};

export type Invitation = {
  id: number;
  invitacionUid: string,
  carpetasPaths?: string | string[],
  ndaUid: string,
  ndaEnvelopeId: string,
  ndaEstado: string,
  email: string,
  token: string,
  codigoControl: string,
  fechaExpiracionCodigo: string,
  estadoInvitacion: string,
  ndaMetadata: string,
  lastAccessAt: string,
  type: string,
  nameOportunidad?: string,
  codigoOportunidad?: string,
  createdAt: string,
  updatedAt: string,
  documentos:Document[]
};

export type InvitationData = {
  invitacionUid: string,
  ndaUid: string,
  ndaEnvelopeId: string,
  ndaEstado: string,
};

export type GroupedDocument = {
  label: string | null;
  children: Document[];
};

export enum ContactType {
  PRIMARY_CONTACT = 'PRIMARY_CONTACT',
  SECONDARY_CONTACT = 'SECONDARY_CONTACT',
  INTERMEDIARY = 'INTERMEDIARY',
  LEGAL_REPRESENTATIVE = 'LEGAL_REPRESENTATIVE',
  LAWYER = 'LAWYER',
}
